import React from 'react';
import { Button } from 'chic-ui';
import { Row } from 'react-bootstrap';

const Loading = () => {
  return (
    <>
      <h4 className="mt-5">Loading</h4>
      <p>
        You can use these buttons to show some loading actions using the{' '}
        <i>loading</i> prop.
      </p>
      <div className="btn-group btns mt-3">
        <Button className="single-btn" loading />
        <Button className="single-btn" loading type='success'/>
      </div>
      <Row className="mt-3" fluid>
        <code>
          {'import { Button } from "chic-ui";'}
          <br />
          {'<Button loading />'}
          <br />
          {'<Button type="success" loading />'}
        </code>
      </Row>
    </>
  );
};

export default Loading;
